import * as yup from 'yup';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
export const useChangePasswordValidationSchema = () => {
    const { t } = useTranslation();
    return yup.object().shape({
        password: Yup.string(),
        newPassword: Yup.string(),
        confirmPassword: Yup.string()
            .required(t('validation.password.required'))
            .oneOf([Yup.ref('newPassword'), null], t('validation.password.confirm'))
    });
};
